import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:4000";

// The notification routes are authenticated now (they used to be wide open, and
// /users leaked every account's email). Same helper the other hooks use.
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return { headers: { Authorization: token ? `Bearer ${token}` : "" } };
};

export const getNotifications = async (data) => {
  const { data: response } = await axios.post(
    `${API}/api/notifications/user`,
    data,
    authHeaders()
  );
  return response;
};

export const getAllNotifications = async () => {
  const { data: response } = await axios.get(`${API}/api/notifications`, authHeaders());
  return response;
};

export const createNotification = async (data) => {
  const { data: response } = await axios.post(
    `${API}/api/notifications/create`,
    data.variables,
    authHeaders()
  );
  return response;
};

export const deleteNotification = async (data) => {
  const { data: response } = await axios.post(
    `${API}/api/notifications/delete`,
    data.variables,
    authHeaders()
  );
  return response;
};

export const readNotification = async (data) => {
  const { data: response } = await axios.post(
    `${API}/api/notifications/read`,
    data.variables,
    authHeaders()
  );
  return response;
};

export const readAllNotifications = async () => {
  const { data: response } = await axios.post(
    `${API}/api/notifications/read-all`,
    {},
    authHeaders()
  );
  return response;
};

export const getNotificationUsers = async () => {
  const { data: response } = await axios.get(`${API}/api/notifications/users`, authHeaders());
  return response;
};
